import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import IconButton from '../IconButton/IconButton'
import MenuIcon from '@mui/icons-material/Menu'

import messages from './HamburgerMenu.messages'

import { styled } from '@mui/material/styles'

export interface IOwnProps {
  className?: string;
  onClick?: () => void
}

export type IProps = IOwnProps

const HamburgerMenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}))

const HamburgerMenu:React.FC<IProps> = (props) => {
  const {
    className,
    onClick,
  } = props

  const intl = useIntl()

  return (
    <div className={className}>
      <HamburgerMenuButton
        onClick={onClick}
        icon={<MenuIcon />}
        ariaLabel={intl.formatMessage({...messages.ariaLabel})}
      />
      <FormattedMessage {...messages.title} />
    </div>
  )
}

export default styled(HamburgerMenu)({
  fontSize: '15px',
  fontWeight: 600,
})
